var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.1538H26V24H0V22.1538ZM21.7286 6.46154C22.4714 5.72308 22.4714 4.61538 21.7286 3.87692L18.3857 0.553846C17.6429 -0.184615 16.5286 -0.184615 15.7857 0.553846L1.85714 14.4V20.3077H7.8L21.7286 6.46154ZM17.0857 1.84615L20.4286 5.16923L17.6429 7.93846L14.3 4.61538L17.0857 1.84615ZM3.71429 18.4615V15.1385L13 5.90769L16.3429 9.23077L7.05714 18.4615H3.71429Z",
    fill: "#0061D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.5d559bca2e363e8e356b447d8c93e0b3.svg";
export { ForwardRef as ReactComponent };